import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import "react-datepicker/dist/react-datepicker.css";
import { format as stringFormat } from 'react-string-format';

import { userGroupUrlCheck } from '../../../utils/userGroupUrlCheck';

import { MSG_RECORDED_ADDED_SUCCESS, MSG_NOT_FOUND, MSG_RECORDED_DELETE_SUCCESS, MSG_RECORDED_UPDATED_SUCCESS, MSG_DELETE_VECHICLE_DETAILS, MSG_VEHICLE_FIELD_ADD_ERROR, MSG_VEHICLE_FIELD_DELETE_ERROR, MSG_DELETE_VECHICLE_FIELD } from '../../../configs/msgConfigs';
import { LBL_DELETE, LBL_ADD_VEHICLE_FIELDS, LBL_SAVE, LBL_BTN_ADDNEW, LBL_SLNUM, LBL_FIELD_NAME, LBL_FIELD_TYPE, LBL_CREW_VISIBILITY, LBL_CLIENT_VISIBILITY, LBL_MANDATORY_FIELD, LBL_VEHICLE_INFO, LBL_APP_NAME, LBL_SETTINGS, LBL_CONFIRM_DELETE, LBL_BACK_TO_SETTINGS, LBL_SELECT, LBL_ADD_VEHICLE_FIELD } from '../../../configs/labelConfigs';
import { DYNAMIC_FIELDS_TYPES, DELETE_SYMBOL, ROUTE_AFFILIATE_SETTINGS, LOGIN_SUPER_ADMIN_GROUP, LOGIN_AFFILIATE_GROUP, STR_VEHICLE_INFO } from '../../../configs/staticConfigs';

import Toast from '../../commons/helpers/toast';
import ModalWindow from '../../commons/helpers/modalWindow';

import { clearAction } from '../../../actions/commonActions';
import { dynamicFieldsListAction } from '../../../actions/settings/dynamicFieldsActions'; 
import { listFieldDetails, saveFieldDetails, deleteFieldDetails } from '../../../actions/settings/affiliates/vehicleInfoAction';
import { LIST_FIELD_DETAILS_SUCCESS, SAVE_FIELD_DETAILS_SUCCESS, SAVE_FIELD_DETAILS_ERROR,  DYNAMIC_FIELDS_LIST_SUCCESS, DELETE_FIELD_DETAILS_SUCCESS, DELETE_FIELD_DETAILS_ERROR } from '../../../actions';

class AffiliateVehicleInfo extends Component {

    constructor(props) {
        super(props)
        this.vehicleDetailsModal = React.createRef();
        let userGroupData = userGroupUrlCheck(this.props.location);
        let profileId = '';
        if (userGroupData !== undefined) {
            profileId = userGroupData.profile_id;
        }
        this.state = {
            formErrors: {},
            infoFormErrors: {},
            commonErrMsg: '',
            valueErrMsg: '',
            fieldDetails: [],
            affiliate: parseInt(profileId),
            toastMessagePop: '',
            toastFlagPop: false,
            toastSuccessPop: true,
            deleteId: 0,
            editId: 0,
            vehicleFieldsMasterList: [], 
            selectedFieldIds: [],
            selectedField: {},
        }

        this.modalAdd = React.createRef();
        this.modalDelete = React.createRef();
    }

    onCloseToastPop = () => { // USED FOR POPUP clientContactAdd
        this.setState({ toastFlagPop: false, toastMessagePop: '', toastSuccessPop: false });
    }

    setToasterStatePop = (isEnabled, message, isSucces, isAutoHide = true) => {
        this.setState({ toastFlagPop: isEnabled, toastMessagePop: message, toastSuccessPop: isSucces });
        if (isAutoHide) {
            setTimeout(() => {
                this.onCloseToastPop();
            }, 3000);
        }
    }

    componentDidMount() {
        document.body.classList.add('body-affiliate');
        document.title = LBL_APP_NAME + " - " + LBL_SETTINGS + " -  " + LBL_VEHICLE_INFO;
        // this.props.listFieldDetails();
        // this.props.listVehicleInfo();
    }

    componentDidUpdate(prevProps) {
        let { vehicleInfoActivity, vehicleInfoStatus, fieldDetailsList, vehicleInfoList, vehicleInfoRetrieve, vehicleFieldsMasterList, vehicleFieldsMasterStatus, vehicleFieldsMasterActivity, dynFieldsAllItems, dynFieldsStatus, dynFieldsActivity } = this.props;

        if ((dynFieldsActivity !== prevProps.dynFieldsActivity) || (vehicleFieldsMasterStatus!== prevProps.vehicleFieldsMasterStatus)) { 
            var arrRespMaster = dynFieldsActivity.split('~~');
            var actStringMaster = arrRespMaster[0];
            if (actStringMaster === DYNAMIC_FIELDS_LIST_SUCCESS) {
                this.props.clearAction();
                let aciveFields = []; 
                let field_details = []; 
                aciveFields = dynFieldsAllItems.filter(item => item.name.trim().toLowerCase()===STR_VEHICLE_INFO.toLowerCase());
                if(aciveFields.length > 0) {
                    aciveFields.forEach(element => {
                        if(!this.state.fieldDetails.find(item => item.vehicle_field_master==element.id)) {
                            field_details.push(element); 
                        }
                    });
                    this.setState({ vehicleFieldsMasterList: field_details});  
                }
                else {
                    this.setState({ vehicleFieldsMasterList: field_details});  
                }
            }
        }

        // if ((vehicleFieldsMasterActivity !== prevProps.vehicleFieldsMasterActivity) || (vehicleFieldsMasterStatus!== prevProps.vehicleFieldsMasterStatus)) { 
        //     var arrRespMaster = vehicleFieldsMasterActivity.split('~~');
        //     var actStringMaster = arrRespMaster[0];
        //     if (actStringMaster === LIST_FIELD_DETAILS_SUCCESS) {
        //         this.props.clearAction();
        //         let aciveFields = []; 
        //         let field_details = []; 
        //         aciveFields = vehicleFieldsMasterList.filter(item => item.is_active===true);
        //         if(aciveFields.length > 0) {
        //             aciveFields.forEach(element => {
        //                 if(!this.state.fieldDetails.find(item => item.vehicle_field_master==element.id)) {
        //                     field_details.push(element); 
        //                 }
        //             });
        //             this.setState({ vehicleFieldsMasterList: field_details});  
        //         }
        //         else {
        //             this.setState({ vehicleFieldsMasterList: field_details});  
        //         }
        //     }
        // }

        if (vehicleInfoActivity && (vehicleInfoStatus !== prevProps.status || vehicleInfoActivity !== prevProps.activity)) {
            var arrResp = vehicleInfoActivity.split('~~');
            var actString = arrResp[0];
            if (actString === LIST_FIELD_DETAILS_SUCCESS) {
                this.props.clearAction();
                let field_details = []
                let { formErrors } = this.state;
                this.setState({ fieldDetails: fieldDetailsList, formErrors: formErrors });
            }
            else if (actString === SAVE_FIELD_DETAILS_SUCCESS) {
                this.props.clearAction();
                this.setToasterStatePop(true, MSG_RECORDED_ADDED_SUCCESS, true);
                // this.props.listFieldDetails();
            }
            else if (actString === SAVE_FIELD_DETAILS_ERROR) {
                this.props.clearAction();
                this.setToasterStatePop(true, MSG_VEHICLE_FIELD_ADD_ERROR, false);
            }
            else if (actString === DELETE_FIELD_DETAILS_SUCCESS) {
                this.props.clearAction();
                this.setToasterStatePop(true, MSG_RECORDED_DELETE_SUCCESS, true);
                // this.props.listFieldDetails();
            }
            else if (actString === DELETE_FIELD_DETAILS_ERROR) {
                this.props.clearAction();
                this.setToasterStatePop(true, MSG_VEHICLE_FIELD_DELETE_ERROR, false);
            } 
        }
    }

    addNewRow = (e) => {
        this.setState({selectedFieldIds:[], selectedField:{}}); 
        // FETCH AFFILITATE VEHICLE DYNAMIC FIELDS 
        let listDynData = {groupId:LOGIN_AFFILIATE_GROUP, reqFrom:LOGIN_SUPER_ADMIN_GROUP}; 
        this.props.dynamicFieldsListAction(listDynData); 
        this.modalAdd.current.handleOpenModal();
    }

    onSelectAddnewCheckbox = (event,categId) => { 
        let arrTemp = this.state.selectedFieldIds; 
        if(event.target.checked) {
            if(!arrTemp.includes(categId)) {
                arrTemp.push(categId); 
            }
            this.setState({ selectedFieldIds: arrTemp });
        }
        else {
            const index = arrTemp.indexOf(categId);
            if (index > -1) { 
                arrTemp.splice(index, 1); 
            }
            this.setState({ selectedFieldIds: arrTemp });
        }            
    }

    onSaveFormData = (e) => {
        if(this.state.selectedFieldIds.length===0) {
            return false;
        }
        else {
            let userGroupData = userGroupUrlCheck(this.props.location);
            let affiliate = '';
            let userGroup    = ''; 
            let grpProfileId = ''; 
            if(userGroupData!==undefined){
                userGroup = userGroupData.user_group; 
                grpProfileId = userGroupData.profile_id;
                affiliate = grpProfileId;
            }
            let addData = {
                affiliate: affiliate,
                vehicle_field_master:this.state.selectedFieldIds
            }
            this.props.saveFieldDetails(addData);   
            this.modalAdd.current.handleModelClose();  
        }
    }

    onModalFormReset = (e) => {
        // this.vehicleDetailsModal.current.handleCloseModal(); 
    }

    deleteBtnClick = (e, id) => {
        let newfieldObj = this.state.fieldDetails;
        let selObj = newfieldObj.find(item => item.id == id);
        this.setState({ selectedField: selObj },() => {
            this.modalDelete.current.handleOpenModal();
        });
    }

    onDeleteAction = () => {
        this.modalDelete.current.handleModelClose();
        this.props.deleteFieldDetails(this.state.selectedField.id);
    }

    render() {
        let { fieldDetails, toastMessagePop, toastSuccessPop, toastFlagPop, vehicleFieldsMasterList, selectedFieldIds, selectedField } = this.state;
        let userGroupData = userGroupUrlCheck(this.props.location);
        let lblCrew = 'Staff'
        if (userGroupData !== undefined) {
            if (userGroupData.staff_name) {
                lblCrew = userGroupData.staff_name;
            }
        }
        return (
            <>
            <div className='col-md-8 divFloatLeft padding-left-20 font-14'><Link to={ROUTE_AFFILIATE_SETTINGS}>{LBL_BACK_TO_SETTINGS}</Link> </div>
            <div className="col-md-8">
                <Toast toastDescription={toastMessagePop} toastFlag={toastFlagPop} toastSuccess={toastSuccessPop} closeToast={this.onCloseToastPop} />
                <div className="box">
                    <div className="tab-head tdVeticalMiddle">
                        <div className="float-left tdVeticalMiddle btn marginLeft0"><h6>{LBL_ADD_VEHICLE_FIELDS}</h6></div>
                        <div className="float-right"><button className="btn btn-primary saveBtnMinWidth " onClick={(e) => this.addNewRow(e)} >{LBL_BTN_ADDNEW}</button></div>
                    </div>
                    <div className="box-content">
                        <div className="table-responsive">
                            
                            {this.state.fieldDetails &&
                                <table id="data-table" className='table dynTable'  >
                                    <thead className="text-bold">
                                        <tr>
                                            <th className="text-center widthPer10">{LBL_SLNUM}</th>
                                            <th className="text-center ">{LBL_FIELD_NAME}</th>
                                            <th className="text-center ">{LBL_FIELD_TYPE}</th>
                                            {/* <th className="text-center ">{stringFormat(LBL_CREW_VISIBILITY, lblCrew)}</th>
                                            <th className="text-center ">{LBL_CLIENT_VISIBILITY}</th> */}
                                            <th className="text-center ">{LBL_MANDATORY_FIELD}</th>
                                            <th className="text-center "></th>
                                        </tr>
                                    </thead>
                                    <tbody>

                                        {fieldDetails.length==0 && <tr>
                                            <td className="text-center" colSpan="6">{MSG_NOT_FOUND}</td>
                                        </tr>}

                                        {fieldDetails.length > 0 && fieldDetails.map((fieldObj, fieldIndex) => {
                                            let fieldType = DYNAMIC_FIELDS_TYPES.filter(item => item.value==fieldObj.field_type)
                                            return (
                                                <tr key={fieldObj.field_id}>

                                                    <td className="text-center">{fieldIndex + 1}</td>
                                                    <td className="">{fieldObj.field_name}</td>
                                                    <td className="text-center">
                                                        {fieldType[0].code ? fieldType[0].code : ''} 
                                                    </td>
                                                    {/* <td className="text-center">
                                                        <div className="custom-checkbox">
                                                            <input name={"chk_fieldCrewVisibility_" + fieldObj.field_id} type="checkbox" id={"chk_fieldCrewVisibility_" + fieldObj.field_id} checked={fieldObj.crew_visibility} onChange={(e) => this.onHandleChange(e, fieldObj.field_id, 'crew_visibility')} /> <label className="checkbox" htmlFor={"chk_fieldCrewVisibility_" + fieldObj.field_id}></label>
                                                        </div>
                                                    </td>
                                                    <td className="text-center">
                                                        <div className="custom-checkbox">
                                                            <input name={"chk_fieldClientVisibility_" + fieldObj.field_id} type="checkbox" id={"chk_fieldClientVisibility_" + fieldObj.field_id} checked={fieldObj.client_visibility} onChange={(e) => this.onHandleChange(e, fieldObj.field_id, 'client_visibility')} /> <label className="checkbox" htmlFor={"chk_fieldClientVisibility_" + fieldObj.field_id}></label>
                                                        </div>
                                                    </td> */}
                                                    <td className="text-center">
                                                        {fieldObj.is_mandatory?'Y':'N'}
                                                    </td>
                                                    <td className="text-center"><i className={DELETE_SYMBOL} title='Remove this Row' onMouseDown={(e) => this.deleteBtnClick(e, fieldObj.id)} ></i>&nbsp;</td>

                                                </tr>
                                            )  // DYNAMIC_FIELDS_TYPES 
                                        }
                                        )}
                                    </tbody>
                                </table>
                            }
                        </div>
                    </div>

                    <div className="tab-head col-12">
                        {this.state.commonErrMsg.length > 0 && (
                            <div className="text-red text-12 text-right">{this.state.commonErrMsg}</div>)}

                        {/* <div className="float-right">
                            {fieldDetails.length > 0 && <button type="button" className="btn btn-primary saveBtnMinWidth" onClick={(e) => this.onSaveFieldDetails(e)} >{LBL_SAVE}</button>}
                        </div> */}
                    </div>
                </div>

                <ModalWindow ref={this.modalDelete} header={LBL_CONFIRM_DELETE} type="delete" deleteItem={this.onDeleteAction} resetModalForm={this.onModalFormReset}>
                    {stringFormat(MSG_DELETE_VECHICLE_FIELD,"'"+selectedField.field_name+"'")}
                </ModalWindow>

                <ModalWindow ref={this.modalAdd} header={LBL_ADD_VEHICLE_FIELD} saveFormData={ (e)=>this.onSaveFormData()} resetModalForm={this.onModalFormReset} type="save" saveButtonText={" Add "} >
                    <div className="table-responsive">
                        <table id="data-table" className='table dynTable'  >
                            <thead className="text-bold">
                                <tr>
                                    <th className="text-center widthPer10">{LBL_SELECT}</th>
                                    <th className="text-center ">{LBL_FIELD_NAME}</th>
                                    <th className="text-center ">{LBL_FIELD_TYPE}</th>
                                    {/* <th className="text-center ">{stringFormat(LBL_CREW_VISIBILITY, lblCrew)}</th>
                                    <th className="text-center ">{LBL_CLIENT_VISIBILITY}</th> */}
                                    <th className="text-center ">{LBL_MANDATORY_FIELD}</th>
                                    <th className="text-center ">&nbsp;</th>
                                </tr>
                            </thead>
                            <tbody>
                                {vehicleFieldsMasterList.length == 0 && <tr>
                                    <td className="text-center" colSpan={5}>{MSG_NOT_FOUND}</td></tr>}

                                {vehicleFieldsMasterList.map((fieldObj, fieldIndex) => {
                                    let fieldType = DYNAMIC_FIELDS_TYPES.filter(item => item.value==fieldObj.field_type)
                                    return (
                                        <tr key={fieldObj.id}>
                                            <td className="text-center">
                                                <div className="custom-checkbox">
                                                    <input name={"chk_field_" + fieldObj.id} type="checkbox" id={"chk_field_" + fieldObj.id} checked={selectedFieldIds.includes(fieldObj.id)?true:false} onChange={(e) => this.onSelectAddnewCheckbox(e,fieldObj.id)} /> <label className="checkbox" htmlFor={"chk_field_" + fieldObj.id}></label>
                                                </div>
                                            </td>
                                            <td className="">{fieldObj.field_name}</td>
                                            <td className="text-center">{fieldType[0]?.code ? fieldType[0].code : ''} </td>
                                            {/* <td className="text-center">
                                                <div className="custom-checkbox">
                                                    <input name={"chk_fieldCrewVisibility_" + fieldObj.field_id} type="checkbox" id={"chk_fieldCrewVisibility_" + fieldObj.field_id} checked={fieldObj.crew_visibility} onChange={(e) => this.onHandleChange(e, fieldObj.field_id, 'crew_visibility')} /> <label className="checkbox" htmlFor={"chk_fieldCrewVisibility_" + fieldObj.field_id}></label>
                                                </div>
                                            </td>
                                            <td className="text-center">
                                                <div className="custom-checkbox">
                                                    <input name={"chk_fieldClientVisibility_" + fieldObj.field_id} type="checkbox" id={"chk_fieldClientVisibility_" + fieldObj.field_id} checked={fieldObj.client_visibility} onChange={(e) => this.onHandleChange(e, fieldObj.field_id, 'client_visibility')} /> <label className="checkbox" htmlFor={"chk_fieldClientVisibility_" + fieldObj.field_id}></label>
                                                </div>
                                            </td> */}
                                            <td className="text-center">
                                                {fieldObj.is_mandatory?'Y':'N'}
                                            </td>
                                            <td className="text-center">
                                                
                                            </td>

                                        </tr>
                                    )  
                                }
                                )}
                            </tbody>
                        </table>
                    </div>
                    
                </ModalWindow>  
            </div>
            </>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        fieldDetailsList: state.vehicleInfoData.fieldDetailsList,
        vehicleInfoList: state.vehicleInfoData.vehicleInfoList,
        vehicleInfoStatus: state.vehicleInfoData.vehicleInfoStatus,
        vehicleInfoActivity: state.vehicleInfoData.vehicleInfoActivity,
        fieldDetailsSavedList: state.vehicleInfoData.fieldDetailsSavedList,
        vehicleInfoRetrieve: state.vehicleInfoData.vehicleInfoRetrieve,
        vehicleFieldsMasterList: state.vehicleMasterInfo.vehicleFieldsMasterList,
        vehicleFieldsMasterStatus: state.vehicleMasterInfo.vehicleFieldsMasterStatus,
        vehicleFieldsMasterActivity: state.vehicleMasterInfo.vehicleFieldsMasterActivity,

        dynFieldsAllItems: state.dynamicFields.dynFieldAllItems,
        dynFieldsStatus: state.dynamicFields.status,
        dynFieldsActivity: state.dynamicFields.activity,
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        listFieldDetails: listFieldDetails,
        saveFieldDetails: saveFieldDetails,
        deleteFieldDetails:deleteFieldDetails,
        clearAction: clearAction, 
        dynamicFieldsListAction: dynamicFieldsListAction,
    }, dispatch);
}
export default connect(mapStateToProps, mapDispatchToProps)(AffiliateVehicleInfo);
